<template>
  <Sidebar v-if="!isPublicPage" />

  <div class="d-flex flex-column w-100">
    <Navbar v-if="!isPublicPage" />

    <div id="main-content" class="p-3">
      <router-view />
    </div>
  </div>

  <LoadingOverlay v-if="loading" />
</template>

<script setup lang="ts">
  //#region Imports
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';

  import { useCommonStore } from '@/stores/commonStore';

  import Sidebar from '@/components/Menues/Sidebar.vue';
  import Navbar from './components/Menues/Navbar.vue';
  import LoadingOverlay from './components/LoadingOverlay.vue';
  //#endregion

  const route = useRoute();
  const commonStore = useCommonStore();

  const loading = computed(() => commonStore.status.authLoading);

  const publicPages = ['Login'];
  const isPublicPage = computed(() => route.name != null && route.name != '' && publicPages.includes(route.name.toString()));
</script>

<style lang="scss">
  @import './assets/sass/main.scss';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    min-height: 100vh;
    display: flex;
    background: rgb(242, 243, 248) !important;
  }

  #main-content {
    position: relative;
    background: rgb(242, 243, 248);
  }

  /* Custom scrollbar styling */
  /* Webkit-based browsers (Chrome, Safari) */
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  /* Firefox */
  body {
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
  }
</style>
